import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { DestinataireInput } from 'src/app/shared/models/destinataire_input';
import { Meeting, MeetingPaginated } from 'src/app/shared/models/meeting';
import { Point } from 'src/app/shared/models/point';
import { IRecordTreatedId } from 'src/app/shared/models/api-request/IRecordTreatedId';
import { catchError, map } from 'rxjs/operators';
import {
  IPointSearchActionsQuery,
  ISeanceSearchActionsQuery,
  Point3PSearchQuery,
} from 'src/app/shared/models/request/SearchActionsQuery';
import { IPagedResult } from 'src/app/shared/models/response/IPagedResult';
import {
  IPointActionSearchResult,
  ISeanceActionSearchResult,
  Points3PSearchResult,
} from 'src/app/shared/models/response/ActionsSearchResult';
import { ParticipantLowInfo } from 'src/app/shared/models/participantLowInfo';
import { ParticipantExtraitConforme } from 'src/app/shared/models/participantExtraitConforme.model';
import {
  ExportHistoryMandataire,
  CitoyenPointToExport,
  CitoyenExportHistory,
} from 'src/app/shared/models/export-citoyen-mandataire/export';
import { PrepareISignLots } from 'src/app/shared/models/Isign/prepare-isign-lots';
import { MassGeneration } from 'src/app/shared/models/mass-generation';
import { CountActions } from 'src/app/shared/models/request/count-actions';
import { ChangeStatusPoint } from 'src/app/shared/models/point/change-statut';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  public apiBaseUrl: string;
  public icourrierBaseUrl: string;
  public body: FormData;
  public headers: HttpHeaders; //  = new HttpHeaders();
  public headersFormData: HttpHeaders; //  = new HttpHeaders();
  public params: HttpParams = new HttpParams();
  renumerotationSuccess = new Subject<boolean>();

  constructor(public http: HttpClient) {
    const config = JSON.parse(sessionStorage.getItem('globalConfig'));
    this.apiBaseUrl = config.apiGatewayBaseUrl + '/api/v1';
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    this.headersFormData = new HttpHeaders({
      'Content-Type': 'multipart/form-data',
    });
    this.body = new FormData();
    this.params = new HttpParams();
    this.icourrierBaseUrl = config.apiICourrierBaseUrl;
  }

  //Seance
  getMeetingsByID(id: number): Observable<Meeting> {
    return this.http.get<Meeting>(`${this.apiBaseUrl}/Seances/${id}`);
  }
  getMeetingsByIDArray(id: any[]): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${id}`);
  }
  postSeance(data: any) {
    return this.http.post<any[]>(`${this.apiBaseUrl}/Seances`, data);
  }
  putSeance(id: number, data: Meeting) {
    return this.http.put(`${this.apiBaseUrl}/Seances/${id}`, data);
  }
  deleteMeeting(id: number) {
    return this.http.delete(`${this.apiBaseUrl}/Seances/${id}`);
  }

  getMeetingHistoric(idSeance) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${idSeance}/History`);
  }
  getMeetingsSearch(data): Observable<MeetingPaginated> {
    let params = new HttpParams();
    if (data) {
      Object.keys(data).forEach((key) => (params = params.set(key, data[key])));
    }
    return this.http.get<MeetingPaginated>(`${this.apiBaseUrl}/Seances/Search?${params}`);
  }
  putRenumerotationPoints(id, data): Observable<any[]> {
    return this.http.put<Point[]>(`${this.apiBaseUrl}/Seances/${id}/ReNumerotationsPoints`, data);
  }
  getSeanceRTFDatasStatic(id, type): Observable<any> {
    return this.http.get<any>(`${this.apiBaseUrl}/Seances/${id}/ContenuStaticRTFFiles`, {
      params: { fileType: type },
      responseType: 'blob' as 'json',
    });
  }
  putOneSeanceRTFDatasStatic(id, data, documentName): Observable<any> {
    const body = new FormData();
    body.append('files', data, documentName + '.rtf');
    return this.http.put<any>(`${this.apiBaseUrl}/Seances/${id}/ContenuStaticRTFFiles`, body);
  }
  getSeanceFiles(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${id}/Files`);
  }

  addSeanceFiles(seanceId: number, document, file, extension: string, isAnnexe: boolean): Observable<any[]> {
    const body = new FormData();
    for (const property in document) {
      if (Object.prototype.hasOwnProperty.call(document, property)) {
        body.append(property, document[property]);
      }
    }
    body.append('file', file, file.name);
    return this.http.post<any[]>(
      `${this.apiBaseUrl}/Seances/${seanceId}/Files?extension=${extension}&annexe=${isAnnexe}`,
      body
    );
  }

  addSeanceFilesMultiple(seanceId: number, files: File[], isAnnexe: boolean): Observable<any[]> {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('files', file, file.name);
    });
    return this.http.post<any[]>(`${this.apiBaseUrl}/Seances/${seanceId}/MultipleFiles?annexe=${isAnnexe}`, formData);
  }

  downloadSeanceFile(seanceId: number, fileId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${seanceId}/Files/${fileId}/Download`, {
      responseType: 'blob' as 'json',
    });
  }
  patchSeanceFile(id, fileId, data): Observable<any[]> {
    return this.http.patch<any>(`${this.apiBaseUrl}/Seances/${id}/Files/${fileId}`, data);
  }
  patchSeancesFile(id, data): Observable<any[]> {
    return this.http.patch<any>(`${this.apiBaseUrl}/Seances/${id}/Files`, data);
  }
  deleteSeanceFile(id, idFile): Observable<any[]> {
    return this.http.delete<any[]>(`${this.apiBaseUrl}/Seances/${id}/Files/${idFile}`);
  }
  setSeanceStatutes(data): Observable<any> {
    return this.http.put<any>(`${this.apiBaseUrl}/Seances/ChangeStatutes`, data);
  }
  putReportPoints(id, data) {
    return this.http.put<any>(`${this.apiBaseUrl}/Seances/${id}/Points/Reporter`, data);
  }

  //points
  getPointByID(id: number): Observable<any> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Points/${id}`);
  }
  postCreatePoint(data: Point): Observable<{ id: number }> {
    data.clearDuplicationData();
    return this.http.post<{ id: number }>(`${this.apiBaseUrl}/Points`, data);
  }
  postDuplicatePoint(
    id: number,
    requestBody: Point,
    duplicateDestinataires: boolean,
    duplicateContenu: boolean
  ): Observable<IRecordTreatedId> {
    return this.http.post<IRecordTreatedId>(
      `${this.apiBaseUrl}/Points/${id}/Duplicate?destinataires=${duplicateDestinataires}&contenu=${duplicateContenu}`,
      requestBody
    );
  }
  putUpdatePoint(id: number, data: Point): Observable<Point> {
    new Point(data).clearDuplicationData();
    return this.http.put<Point>(`${this.apiBaseUrl}/Points/${id}`, data);
  }

  modifyPointStatut(id: number, data): Observable<any[]> {
    let params = new HttpParams();
    params = params.set('newStatutId', data);

    return this.http.put<Point[]>(`${this.apiBaseUrl}/Points/${id}/ChangeStatut?${params}`, null);
  }
  getSearchPoint(data: any): Observable<any[]> {
    let params = new HttpParams();
    if (data) {
      Object.keys(data).forEach((key) => (params = params.set(key, data[key])));
    }
    const paramsString: string = params.toString();
    return this.http.get<any[]>(`${this.apiBaseUrl}/Points/Search?${paramsString}`);
  }
  getPointHistoricByID(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Points/${id}/History`);
  }
  getPointFiles(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Points/${id}/Files`);
  }

  addPointFiles(pointId: number, document, file, extension: string, isAnnexe: boolean): Observable<any[]> {
    const body = new FormData();
    for (const property in document) {
      if (Object.prototype.hasOwnProperty.call(document, property)) {
        body.append(property, document[property]);
      }
    }
    body.append('file', file, file.name);
    return this.http.post<any[]>(
      `${this.apiBaseUrl}/Points/${pointId}/Files?extension=${extension}&annexe=${isAnnexe}`,
      body
    );
  }

  addPointFilesMultiple(pointId: number, files: File[], isAnnexe: boolean): Observable<any[]> {
    const formData = new FormData();
    files.forEach((file, index) => {
      formData.append('files', file, file.name);
    });

    return this.http.post<any[]>(`${this.apiBaseUrl}/Points/${pointId}/MultipleFiles?annexe=${isAnnexe}`, formData);
  }

  downloadPointFile(pointId: number, fileId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Points/${pointId}/Files/${fileId}/Download`, {
      responseType: 'blob' as 'json',
    });
  }
  patchPointFile(id, fileId, data): Observable<any[]> {
    return this.http.patch<any>(`${this.apiBaseUrl}/Points/${id}/Files/${fileId}`, data);
  }
  patchPointsFile(id, data): Observable<any[]> {
    return this.http.patch<any>(`${this.apiBaseUrl}/Points/${id}/Files`, data);
  }
  deletePointFile(id, idFile): Observable<any[]> {
    return this.http.delete<any[]>(`${this.apiBaseUrl}/Points/${id}/Files/${idFile}`);
  }

  getPointRTFDatasStatic(id, type): Observable<Blob> {
    return this.http.get<Blob>(`${this.apiBaseUrl}/Points/${id}/ContenuStaticRTFFiles`, {
      params: { fileType: type },
      responseType: 'blob' as 'json',
    });
  }
  getPointContenuStaticRTFFilesPresents(id): Observable<any> {
    return this.http.get<any>(`${this.apiBaseUrl}/Points/${id}/ContenuStaticRTFFilesPresents`);
  }
  putOnePointRTFDatasStatic(id, data, documentName): Observable<any> {
    const body = new FormData();
    body.append('files', data, documentName + '.rtf');
    return this.http.put<any>(`${this.apiBaseUrl}/Points/${id}/ContenuStaticRTFFiles`, body);
  }
  putMultiplePointRTFDatasStatic(id, data: Array<Blob>, documentsNames: Array<string>): Observable<any> {
    const body = new FormData();
    for (let i = 0; i < data.length; i++) {
      body.append('files', data[i], documentsNames[i] + '.rtf');
    }
    return this.http.put<any>(`${this.apiBaseUrl}/Points/${id}/ContenuStaticRTFFiles`, body);
  }

  //agent traitant
  getAllHandlers(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Handlers`);
  }

  //urgence
  getAllEmergencies(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Emergencies`);
  }

  //code
  getAllCodes(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Codes`);
  }

  //type de décision
  getAllDecisionTypes(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/DecisionTypes`);
  }

  //Participants
  postParticipantSeance(id: number, data: any): Observable<any[]> {
    return this.http.post<any[]>(`${this.apiBaseUrl}/Seances/${id}/Participants`, data);
  }
  putParticipantsSeance(id: number, idParticipant: number, data: any): Observable<any[]> {
    return this.http.put<Point[]>(`${this.apiBaseUrl}/Seances/${id}/Participants/${idParticipant}`, data);
  }
  deleteParticipantSeance(id: number, idParticipant): Observable<{ count: number }> {
    return this.http.delete<{ count: number }>(
      `${this.apiBaseUrl}/Seances/${id}/Participants?participantIds=${idParticipant}`
    );
  }

  //destinataires
  getDestinatairesFull(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Points/${id}/Destinataires/Full`);
  }

  public setPointRecipientAsDefaultOne(pointId: number, recipientId: number): Observable<unknown> {
    return this.http.put<any>(`${this.apiBaseUrl}/Points/${pointId}/Destinataires/${recipientId}/SetPrincipal`, {});
  }

  addDestinatairesInPoint(id: number, data: any): Observable<any[]> {
    return this.http.post<any>(`${this.apiBaseUrl}/Points/${id}/Users`, data);
  }
  addOrReplaceDestinatairesInPoint(id: number, data: any): Observable<any[]> {
    return this.http.post<any>(`${this.apiBaseUrl}/Points/${id}/Users/Actions/AddOrReplace`, data);
  }
  deleteDestinatairePoint(id: number, data) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: { destinataires: data },
    };
    return this.http.delete<any[]>(`${this.apiBaseUrl}/Points/${id}/Users`, options);
  }

  // Destinataire séances

  getDestinatairesFullMeeting(id: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${id}/Destinataires/Full`);
  }
  setDestinatairePrincipalMeeting(id: number, destinataireP: DestinataireInput): Observable<any[]> {
    return this.http.put<any>(`${this.apiBaseUrl}/Seances/${id}/Destinataires/SetPrincipal`, destinataireP);
  }

  addDestinatairesInMeeting(id: number, data: any): Observable<any[]> {
    return this.http.post<any>(`${this.apiBaseUrl}/Seances/${id}/Users`, data);
  }
  addOrReplaceDestinatairesInMeeting(id: number, data: any): Observable<any[]> {
    return this.http.post<any>(`${this.apiBaseUrl}/Seances/${id}/Users/Actions/AddOrReplace`, data);
  }
  deleteDestinataireMeeting(id: number, data) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: { destinataires: data },
    };
    return this.http.delete<any[]>(`${this.apiBaseUrl}/Seances/${id}/Users`, options);
  }

  replyToPointAction(id: number, actionId: number, actionReply: any): Observable<any> {
    return this.http.post<any>(`${this.apiBaseUrl}/Points/${id}/Actions/${actionId}/Reply`, actionReply);
  }

  replyToMeetingAction(id: number, actionId: number, actionReply: any): Observable<any> {
    return this.http.post<any>(`${this.apiBaseUrl}/Seances/${id}/Actions/${actionId}/Reply`, actionReply);
  }

  getMeetingsByTypes(typeMeetingId) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Points/SeanceAvailables?typeSeanceId=${typeMeetingId}`);
  }

  getMeetingsPointsInclusWithEvents(id: number) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${id}/PointsInclusWithEvents`);
  }
  getMeetingsPointsInclusWithEventsTree(id: number, countEvenements: boolean = false) {
    return this.http.get<any[]>(
      `${this.apiBaseUrl}/Seances/${id}/PointsInclusWithEventsTree?countEvenements=${countEvenements}`
    );
  }

  getMeetingsPointsInclusWithEventsOrdered(id: number, countEvenements: boolean = false) {
    return this.http.get<any[]>(
      `${this.apiBaseUrl}/Seances/${id}/PointsInclusWithEventsOrdered?countEvenements=${countEvenements}`
    );
  }

  getMeetingsPointsInclus(id: number) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${id}/PointsInclus`);
  }

  getMeetingsPointsNonInclus(id: number) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${id}/PointsNonInclus`);
  }

  postEventByMeetingID(id: number, data: any) {
    return this.http.post<any[]>(`${this.apiBaseUrl}/Seances/${id}/Events`, data);
  }

  putEventByMeetingID(id: number, eventId: number, data: any) {
    return this.http.put<any[]>(`${this.apiBaseUrl}/Seances/${id}/Events/${eventId}`, data);
  }
  deleteventByMeetingID(id: number, eventId: number) {
    return this.http.delete<any[]>(`${this.apiBaseUrl}/Seances/${id}/Events?eventIds=${eventId}`);
  }

  getSeancesByIDCount(meetingID: number, tags: any) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${meetingID}/Count?tags=${tags}`);
  }

  getParticipantsByMeetingID(meetingID: number) {
    return this.http.get<ParticipantLowInfo[]>(`${this.apiBaseUrl}/Seances/${meetingID}/Participants`);
  }

  getParticipantsExtraitConformeByMeetingID(meetingID: number): Observable<any> {
    return this.http.get<ParticipantExtraitConforme[]>(
      `${this.apiBaseUrl}/Seances/${meetingID}/ExtraitConformes/Participants`
    );
  }

  pointsVerrouiller(meetingID: number, data: any) {
    return this.http.put<any[]>(`${this.apiBaseUrl}/Seances/${meetingID}/Points/Verrouiller`, data);
  }

  pointsCloturer(meetingID: number, data: any) {
    return this.http.put<any[]>(`${this.apiBaseUrl}/Seances/${meetingID}/Points/Cloturer`, data);
  }

  markACorriger(meetingID: number, data: any) {
    return this.http.put<any[]>(`${this.apiBaseUrl}/Seances/${meetingID}/Points/MarkACorriger`, data);
  }

  validerCorrection(pointID: number) {
    return this.http.put<any[]>(`${this.apiBaseUrl}/Points/${pointID}/ValiderCorrections`, { header: this.headers });
  }

  removePoint(meetingID: number, pointId: number) {
    return this.http.put<any[]>(`${this.apiBaseUrl}/Seances/${meetingID}/Points/${pointId}/Remove`, {
      header: this.headers,
    });
  }

  getVotesByPointID(meetingID: number, pointID: number) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${meetingID}/Points/${pointID}/Votes`);
  }

  getVotesParticipants(meetingID: number, pointID: number) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${meetingID}/Points/${pointID}/Votes/Participants`);
  }

  changeVotes(meetingID: number, pointID: number, data) {
    return this.http.put<any[]>(`${this.apiBaseUrl}/Seances/${meetingID}/Points/${pointID}/Votes`, data);
  }
  changeMassVotes(meetingId, pointIds) {
    const data = {
      pointIds: pointIds,
    };
    return this.http.put<any[]>(`${this.apiBaseUrl}/Seances/${meetingId}/Points/Votes`, data);
  }

  postChangeStatusPoint(data) {
    return this.http.post<any[]>(`${this.apiBaseUrl}/Points/ChangeStatutCheck`, data);
  }
  putChangeStatusPoint(pointID: number, statusID: number) {
    return this.http.put<any[]>(`${this.apiBaseUrl}/Points/${pointID}/ChangeStatut?newStatutId=${statusID}`, {
      header: this.headers,
    });
  }

  putChangeStatusPoints(body: {
    pointIds: number[];
    newStatutId: number;
    unlock: boolean;
  }): Observable<ChangeStatusPoint> {
    return this.http.put<ChangeStatusPoint>(`${this.apiBaseUrl}/Points/ChangeStatut`, body);
  }

  getModelesDocumentsByPointID(pointID) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Points/${pointID}/ModelesDocuments`);
  }

  getPrepareISignLotsSingleSeance(
    meetingId: number,
    data: { pointIds: number[]; modeleIdsUtilises: number[] }
  ): Observable<PrepareISignLots> {
    return this.http.post<PrepareISignLots>(`${this.apiBaseUrl}/Seances/${meetingId}/PrepareISignLots`, data, {
      headers: this.headers,
    });
  }

  getPrepareISignLotsMultiSeance(data: {
    seanceIds: number[];
    modeleIdsUtilises: number[];
  }): Observable<PrepareISignLots> {
    return this.http.post<PrepareISignLots>(`${this.apiBaseUrl}/Seances/PrepareISignLots`, data, {
      headers: this.headers,
    });
  }

  sendDocMeetingToIsign(data: { seanceIds: number[]; modeleIdsUtilises: number[] }): Observable<{ count: number }> {
    return this.http.post<{ count: number }>(`${this.apiBaseUrl}/Seances/ModelesDocuments/sendToiSign`, data, {
      headers: this.headers,
    });
  }
  sendDocPointToIsign(
    meetingId: number,
    data: { pointIds: number[]; modeleIdsUtilises: number[] }
  ): Observable<{ count: number }> {
    return this.http.post<{ count: number }>(
      `${this.apiBaseUrl}/Seances/${meetingId}/Points/ModelesDocuments/sendToiSign`,
      data,
      { headers: this.headers }
    );
  }

  mergeDocuments(
    meetingId: number,
    modelId: number,
    pointIds: { pointIds: number[] },
    ConcatExtraitConforme?: boolean
  ): Observable<number[]> {
    return this.http.post<number[]>(`${this.apiBaseUrl}/Seances/${meetingId}/ModelesDocuments/${modelId}/ConcatPDFs`, {
      pointIds: pointIds.pointIds,
      ConcatExtraitConforme,
    });
  }

  previewRequestsModelDoc(pointID: number, modeleId: number, uiOpenRtfToEdit: boolean = false) {
    return this.http.post<any[]>(
      `${this.apiBaseUrl}/Points/${pointID}/ModelesDocuments/${modeleId}/PreviewRequests?uiOpenRtfToEdit=${uiOpenRtfToEdit}`,
      this.headers
    );
  }

  previewRequestsCancelModelDoc(pointID: number, modeleId: number, previewId: string) {
    return this.http.put<any[]>(
      `${this.apiBaseUrl}/Points/${pointID}/ModelesDocuments/${modeleId}/PreviewRequests/${previewId}/Cancel`,
      this.headers
    );
  }

  downloadModeleDocument(pointID: number, modeleId: number) {
    return this.http.get<Blob>(`${this.apiBaseUrl}/Points/${pointID}/ModelesDocuments/${modeleId}/DownloadPdf`, {
      responseType: 'blob' as 'json',
    });
  }

  downloadModeleDocumentRTF(pointID: number, modeleId: number, generatedAndSaved: boolean) {
    return this.http.get<any[]>(
      `${this.apiBaseUrl}/Points/${pointID}/ModelesDocuments/${modeleId}/DownloadRtf?generatedAndSaved=${generatedAndSaved}`,
      { responseType: 'blob' as 'json' }
    );
  }

  getPointsCount(tags) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Points/Count?tags=${tags}`);
  }

  generateModelesDoc(pointID: number, modeleId: number, autoSave?: boolean, uiOpenRtfToEdit?: boolean) {
    if (autoSave === null || autoSave === undefined) {
      autoSave = false;
    }
    if (uiOpenRtfToEdit === null || uiOpenRtfToEdit === undefined) {
      uiOpenRtfToEdit = false;
    }

    const params = [];

    if (autoSave !== undefined) {
      params.push(`autoSave=${autoSave}`);
    }
    if (uiOpenRtfToEdit !== undefined) {
      params.push(`uiOpenRtfToEdit=${uiOpenRtfToEdit}`);
    }

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    const url = `${this.apiBaseUrl}/Points/${pointID}/ModelesDocuments/${modeleId}/Generate${queryString}`;

    return this.http.post<any[]>(url, this.headers);
  }

  generateModelesDocConforme(pointId: number, modeleId: number, requestBody: any) {
    const url = `${this.apiBaseUrl}/Points/${pointId}/ModelesDocuments/${modeleId}/ExtraitConformes/Generate`;

    const body = requestBody ? requestBody : {};
    return this.http.post<any[]>(url, body);
  }

  getRightsGeneration(seanceId: number, modeleId: number, pointIds: number[]) {
    return this.http.post<any[]>(
      `${this.apiBaseUrl}/Seances/${seanceId}/ExtraitConformes/${modeleId}/MassGenerationCheck`,
      { pointIds }
    );
  }

  uploadRtfModeleDoc(pointID: number, modeleId: number, data) {
    const body = new FormData();
    for (const property in data) {
      if (Object.prototype.hasOwnProperty.call(data, property)) {
        body.append(property, data[property]);
      }
    }
    return this.http.post<any[]>(`${this.apiBaseUrl}/Points/${pointID}/ModelesDocuments/${modeleId}/UploadRtf`, body);
  }

  getModelesDocumentsByMeetingID(MeetingID) {
    return this.http.get<any[]>(`${this.apiBaseUrl}/Seances/${MeetingID}/ModelesDocuments`);
  }

  previewRequestsMeetingModelDoc(meetingID: number, modeleId: number, uiOpenRtfToEdit: boolean = false) {
    return this.http.post<any[]>(
      `${this.apiBaseUrl}/Seances/${meetingID}/ModelesDocuments/${modeleId}/PreviewRequests?uiOpenRtfToEdit=${uiOpenRtfToEdit}`,
      { header: this.headers }
    );
  }

  previewRequestsMeetingCancelModelDoc(meetingID: number, modeleId: number, previewId: string) {
    return this.http.put<any[]>(
      `${this.apiBaseUrl}/Seances/${meetingID}/ModelesDocuments/${modeleId}/PreviewRequests/${previewId}/Cancel`,
      { header: this.headers }
    );
  }

  downloadMeetingModeleDocument(meetingID: number, modeleId: number) {
    return this.http.get<Blob>(`${this.apiBaseUrl}/Seances/${meetingID}/ModelesDocuments/${modeleId}/DownloadPdf`, {
      responseType: 'blob' as 'json',
    });
  }

  downloadMeetingModeleDocumentRTF(meetingID: number, modeleId: number, generatedAndSaved: boolean) {
    return this.http.get<any[]>(
      `${this.apiBaseUrl}/Seances/${meetingID}/ModelesDocuments/${modeleId}/DownloadRtf?generatedAndSaved=${generatedAndSaved}`,
      { responseType: 'blob' as 'json' }
    );
  }

  generateModelesDocMeeting(
    meetingID: number,
    modeleId: number,
    autoSave?: boolean,
    uiOpenRtfToEdit?: boolean,
    requestBody?: any
  ) {
    if (autoSave === null) {
      autoSave = false;
    }
    if (uiOpenRtfToEdit === null) {
      uiOpenRtfToEdit = false;
    }

    const body = requestBody ? requestBody : {};
    return this.http.post<any[]>(
      `${this.apiBaseUrl}/Seances/${meetingID}/ModelesDocuments/${modeleId}/Generate?autoSave=${autoSave}&uiOpenRtfToEdit=${uiOpenRtfToEdit}`,
      body
    );
  }

  uploadRtfModeleDocMeeting(meetingID: number, modeleId: number, data) {
    const body = new FormData();
    for (const property in data) {
      if (Object.prototype.hasOwnProperty.call(data, property)) {
        body.append(property, data[property]);
      }
    }
    return this.http.post<any[]>(
      `${this.apiBaseUrl}/Seances/${meetingID}/ModelesDocuments/${modeleId}/UploadRtf`,
      body
    );
  }

  //* Gets the infos for the export mandataires of the given meeting
  getExportsDelibeMandataire(meetingID: number): Observable<ExportHistoryMandataire> {
    return this.http.get<ExportHistoryMandataire>(
      `${this.apiBaseUrl}/Connecteurs/IDelibeMandataires/Seances/${meetingID}/ExportHistory`,
      { headers: this.headers }
    );
  }

  //* Execute the export Mandataire for the given meetingId
  exportMandataireNow(meetingID: number, data): Observable<boolean> {
    return this.http.post<boolean>(
      `${this.apiBaseUrl}/Connecteurs/IDelibeMandataires/Seances/${meetingID}/Export`,
      data,
      { headers: this.headers }
    );
  }

  //* get the points checked or not to export for citoyen
  getExportCitoyenPoints(meetingId): Observable<CitoyenPointToExport[]> {
    return this.http.get<CitoyenPointToExport[]>(
      `${this.apiBaseUrl}/Connecteurs/IDelibeCitoyens/Seances/${meetingId}/PointsToExport`,
      { headers: this.headers }
    );
  }

  //* Gets the infos for the export mandataires of the given meeting
  getExportsDelibeCitoyen(meetingID: number): Observable<CitoyenExportHistory> {
    return this.http.get<CitoyenExportHistory>(
      `${this.apiBaseUrl}/Connecteurs/IDelibeCitoyens/Seances/${meetingID}/ExportHistory`,
      { headers: this.headers }
    );
  }

  //* Execute the export Mandataire for the given meetingId
  exportCitoyenNow(meetingID: number): Observable<boolean> {
    return this.http.post<boolean>(`${this.apiBaseUrl}/Connecteurs/IDelibeCitoyens/Seances/${meetingID}/Export`, null, {
      headers: this.headers,
    });
  }

  // search actions
  searchPointsActions(searchData: IPointSearchActionsQuery) {
    let params = new HttpParams();
    Object.keys(searchData).forEach((key) => (params = params.set(key, searchData[key])));
    const url = `${this.apiBaseUrl}/Points/Actions/Search?${params}`;
    return this.http.get<IPagedResult<IPointActionSearchResult>>(url);
  }

  searchSeancesActions(searchData: ISeanceSearchActionsQuery) {
    let params = new HttpParams();
    Object.keys(searchData).forEach((key) => (params = params.set(key, searchData[key])));
    const url = `${this.apiBaseUrl}/Seances/Actions/Search?${params}`;
    return this.http.get<IPagedResult<ISeanceActionSearchResult>>(url);
  }

  countPointsActions(): Observable<CountActions> {
    return this.http.get<CountActions>(`${this.apiBaseUrl}/Points/Actions/Count?Tags=All,Todo,Traite,Transmission`);
  }
  countMeetingsActions(): Observable<CountActions> {
    return this.http.get<CountActions>(`${this.apiBaseUrl}/Seances/Actions/Count?Tags=All,Todo,Traite,Transmission`);
  }

  /**
   * * Methods to get icourrier data based on id
   * @param icourrierID:number
   */
  getIcourrierByIdData(icourrierID: number) {
    return this.http.get<any[]>(`${this.icourrierBaseUrl}/Connecteurs/iDelibe/Mails/${icourrierID}`);
  }

  getIcourrierFiles(icourrierID: number) {
    return this.http.get<any[]>(`${this.icourrierBaseUrl}/Connecteurs/iDelibe/Mails/${icourrierID}/Files`);
  }

  postPointFromIcourrier(data) {
    return this.http.post<any[]>(`${this.apiBaseUrl}/Points/FromMail`, data);
  }

  importFromIcourrierFilesPoint(id: number, data: any) {
    return this.http.post<any[]>(`${this.apiBaseUrl}/Points/${id}/Files/ImportFromIcourrier`, data);
  }

  get3PPointSearch(data: Point3PSearchQuery) {
    let params = new HttpParams();
    if (data) {
      Object.keys(data).forEach((key) => (params = params.set(key, data[key])));
    }
    return this.http.get<IPagedResult<Points3PSearchResult>>(`${this.apiBaseUrl}/Points3P/Search?${params}`);
  }

  getContenuStaticFilesFrom3P(id: number, fileType: string) {
    return this.http.get<any[]>(
      `${this.apiBaseUrl}/Points3P/${id}/ContenuStaticRTFFiles/Download?fileType=${fileType}`,
      { responseType: 'blob' as 'json' }
    );
  }
  createFrom3P(data) {
    return this.http.post<any[]>(`${this.apiBaseUrl}/Points3P/CreateFrom3P`, data);
  }

  archivePoint3P(id: number[]): Observable<boolean> {
    return this.http.put<boolean>(`${this.apiBaseUrl}/Points3P/Archive`, { ids: id }, { responseType: 'json' });
  }

  numerotationAuto(id: number) {
    return this.http.put<any[]>(`${this.apiBaseUrl}/Seances/${id}/Points/ReNumerotationAuto`, this.headers);
  }

  massGenerationCheckDocumentInPoint(
    seanceId: number,
    modeleId: number,
    pointIds: Array<number>
  ): Observable<MassGeneration[]> {
    return this.http.post<MassGeneration[]>(
      `${this.apiBaseUrl}/Seances/${seanceId}/ModelesDocuments/${modeleId}/MassGenerationCheck`,
      { pointIds }
    );
  }

  public compliantExtractsbulkGenerationForAPoint(request: {
    seanceId: number;
    modeleId: number;
    body: {
      pointIds: number[];
      ConcatExtraitConforme: boolean;
    };
  }): Observable<MassGeneration[]> {
    const { seanceId, modeleId, body } = request;

    return this.http.post<MassGeneration[]>(
      `${this.apiBaseUrl}/Seances/${seanceId}/ModelesDocuments/${modeleId}/MassGenerationCheck`,
      { ...body }
    );
  }

  massGenerationDocumentInPoint(seanceId: number, modeleId: number, requestBody?: any, overWrite?: boolean) {
    const params = [];

    if (overWrite !== undefined) {
      params.push(`overWrite=${overWrite}`);
    }

    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    const url = `${this.apiBaseUrl}/Seances/${seanceId}/ModelesDocuments/${modeleId}/MassGeneration${queryString}`;

    const body = requestBody ? requestBody : {};
    return this.http.post<any[]>(url, body);
  }

  massGenerationExtraitConforme(seanceId: number, modeleId: number, requestBody?: any) {
    const url = `${this.apiBaseUrl}/Seances/${seanceId}/ExtraitConformes/${modeleId}/MassGeneration`;
    const body = requestBody ? requestBody : {};
    return this.http.post<any[]>(url, body);
  }

  generationExtraitConforme(pointId: number, modeleId: number, requestBody?: any) {
    const url = `${this.apiBaseUrl}/Points/${pointId}/ModelesDocuments/${modeleId}/ExtraitConformes/Generate`;
    const body = requestBody ? requestBody : {};
    return this.http.post<any[]>(url, body);
  }

  /**
   * Locks a point with the given ID by sending a PUT request to the server.
   *
   * @param {number} id - the ID of the point to be locked
   * @return {Observable<Point["writeLock"]>} an observable of the response data from the server
   */
  lockPoint(id: number): Observable<Point['writeLock']> {
    return this.http.put<Point['writeLock']>(`${this.apiBaseUrl}/Points/${id}/WriteLock`, this.headers).pipe(
      map((res) => {
        if (res) {
          return res;
        }
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  /**
   * Release a write lock for a specific ID.
   *
   * @param {number} id - the ID of the point
   * @return {Observable<Point["writeLock"]>} an observable of the write lock information
   */
  ReleaseWriteLock(id: number): Observable<Point['writeLock']> {
    return this.http.put<any>(`${this.apiBaseUrl}/Points/${id}/ReleaseWriteLock`, this.headers);
  }

  deleteIDelibeLinks(pointId: number, idsCourrier: number[]): Observable<void> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        iCourrierIdsToDeleteLink: idsCourrier,
      },
    };
    return this.http.delete<void>(`${this.apiBaseUrl}/Points/${pointId}/Links`, options);
  }

  getActionsStatut(): Observable<any> {
    return this.http.get<any>(`${this.apiBaseUrl}/Global/Actions/Statutes`);
  }

  movePointInMeeting(
    meetingId: number,
    body: { targetPointId: number; pointIds: number[]; beforeTarget: boolean }
  ): Observable<boolean> {
    return this.http.put<boolean>(`${this.apiBaseUrl}/Seances/${meetingId}/Points/Move`, body);
  }
}
